export const FETCH_IMAGES = 'FETCH_IMAGES'
export const FETCH_IMAGES_ERROR = 'FETCH_IMAGES_ERROR'

export const FIND_IMAGES = 'FIND_IMAGES'
export const FIND_IMAGES_ERROR = 'FIND_IMAGES_ERROR'

export const CREATE_IMAGE = 'CREATE_IMAGE'
export const CREATE_IMAGE_ERROR = 'CREATE_IMAGE_ERROR'

export const LIKE_IMAGE = 'LIKE_IMAGE'
export const LIKE_IMAGE_ERROR = 'LIKE_IMAGE_ERROR'

export const SAVE_IMAGE = 'SAVE_IMAGE'
export const SAVE_IMAGE_ERROR = 'SAVE_IMAGE_ERROR'

export const DELETE_IMAGE = 'DELETE_IMAGE'
export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR'

export const UPDATE_IMAGE = 'UPDATE_IMAGE'
export const UPDATE_IMAGE_ERROR = 'UPDATE_IMAGE_ERROR'

// Hate myself (delete this plz))
export const SET_IMAGE_TO_EDIT = 'SET_IMAGE_TO_EDIT'
export const STORE_LIKE = 'STORE_LIKE'

export const SAVE_CREATED_IMAGE = 'SAVE_CREATED_IMAGE'
export const SAVE_CREATED_IMAGE_ERROR = 'SAVE_CREATED_IMAGE_ERROR'

export const EDIT_CREATED_IMAGE = 'EDIT_CREATED_IMAGE'
export const EDIT_CREATED_IMAGE_ERROR = 'EDIT_CREATED_IMAGE_ERROR'

export const DELETE_FROM_USER_IMAGE = 'DELETE_FROM_USER_IMAGE'
export const DELETE_FROM_USER_IMAGE_ERROR = 'DELETE_FROM_USER_IMAGE_ERROR'

export const SIGN_IN_USER = 'SIGN_IN_USER'
export const SIGN_IN_USER_ERROR = 'SIGN_IN_USER_ERROR'

export const SIGN_UP_USER = 'SIGN_UP_USER'
export const SIGN_UP_USER_ERROR = 'SIGN_UP_USER_ERROR'

export const LOG_OUT_USER = 'LOG_OUT_USER'